<template>
  <div class="conditional-screen">
    <el-form label-width="80px" :model="form" :rules="rules" ref="form">
      <el-form-item label="标签名称" class="screen-item" prop="name">
        <el-input
          class="name-input"
          v-model="form.name"
          placeholder="请输入标签名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="选择考试" class="screen-item" prop="examId">
        <el-select
          v-model="form.examId"
          placeholder="请选择"
          @change="examChange"
        >
          <el-option
            v-for="item in gradeExamInfoList"
            :key="item.id"
            :label="item.gradeName + item.title + item.subTitle"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择科目" class="screen-item" prop="courseId">
        <el-select v-model="form.courseId" placeholder="请选择">
          <el-option
            v-for="item in courseFullList"
            :key="item.courseId"
            :label="item.courseName"
            :value="item.courseId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="screen-item">
        <el-radio-group v-model="form.intervalType">
          <el-radio label="排名区间"></el-radio>
          <el-radio label="分数区间"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="interval-num">
        <el-col :span="7">
          <el-input-number
            v-model="form.minNum"
            :min="0"
            :max="100000"
            label="描述文字"
          ></el-input-number>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="7">
          <el-input-number
            v-model="form.maxNum"
            :min="0"
            :max="100000"
            label="描述文字"
          ></el-input-number>
        </el-col>
      </el-form-item>
    </el-form>
    <div class="btn-list">
      <el-button type="primary" plain @click="back">返回</el-button>
      <el-button type="primary" @click="tagStudentSubmit">确认</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isSelectMode", "gradeExamInfoList"],
  data() {
    return {
      form: {
        name: "",
        courseId: "",
        examId: "",
        intervalType: "排名区间",
        minNum: "",
        maxNum: "",
        gradeId: "",
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        examId: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        courseId: [
          { required: false, message: "请选择活动区域", trigger: "change" },
        ],
      },
      courseFullList: [], // 科目列表
    };
  },
  methods: {
    // 选择标签学生成绩对比点击提交
    tagStudentSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let data = {
            schoolId: this.user.schoolId,
            gradeId: this.form.gradeId,
            examInfoId: this.form.examId,
            labelName: this.form.name,
            courseId: this.form.courseId,
            minInterval: this.form.minNum,
            maxInterval: this.form.maxNum,
            status: this.form.intervalType == "排名区间" ? 1 : 2,
          };
          // console.log("data:", data);
          this.$emit("tagStudentSubmit", data);
        } else {
          return false;
        }
      });
    },
    examChange(e) {
      // console.log(e);
      this.form.gradeId = this.gradeExamInfoList.find(
        (item) => item.id == e
      ).gradeId;
      this.getCourseGradeList();
    },
    // 获取科目
    getCourseGradeList() {
      let data = {
        schoolId: this.user.schoolId,
        gradeId: this.form.gradeId,
      };
      this.get(this.$url.getCourseFullList, data).then((res) => {
        // console.log("获取科目分制；", res);
        if (res.code !== 200) return;
        this.courseFullList = res.rows;
      });
    },
    // 返回选择方式
    back() {
      this.courseFullList = [];
      this.form = {
        name: "",
        courseId: "",
        examId: "",
        intervalType: "排名区间",
        minNum: "",
        maxNum: "",
        gradeId: "",
      };
      this.$refs["form"].clearValidate();
      this.$emit("update:isSelectMode", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./conditionalScreen.scss";
</style>